import {memo} from "react";
import {Alert, Col, Descriptions, Drawer, Image, Row, Spin, Tag, Typography} from "antd";
import useSWR from "swr";
import {LinkOutlined, LoadingOutlined} from "@ant-design/icons";
import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'

const { Title } = Typography;

const CourseDrawer = memo(({courseId, visible = false, onClose = () => {}}) => {

    const { data: course, error } = useSWR(courseId ? `/course/${courseId}` : null)

    let Body = memo(() => {
        if (error) {
            return <Row justify={'center'} style={{ marginTop: '24px' }}>
                <Col span={24}>
                    <Alert
                        message="เกิดข้อผิดพลาด"
                        description={`ไม่สามารถดาวน์โหลดข้อมูลได้ กรุณาลองอีกครั้งภายหลัง : ${error}`}
                        type="error"
                        showIcon
                    />
                </Col>
            </Row>
        }

        if(!course) {
            return <>
                <Row justify={'center'} style={{ marginTop: '24px' }}>
                    <Col>
                        <Spin indicator={<LoadingOutlined style={{ fontSize: 72 }} spin />} />
                    </Col>
                </Row>
            </>;
        }

        return <>
            <div className="container">
                <Title level={3}>{course.name} โดย {course.school}</Title>
                <Descriptions
                    title={'รายละเอียดคอร์ส'}
                    layout={'vertical'}
                    labelStyle={{
                        fontWeight: 'bold',
                    }}
                >
                    <Descriptions.Item label="ชื่อคอร์ส" span={2}>{course.name}</Descriptions.Item>
                    <Descriptions.Item label="ค่าใช้จ่าย">{course.expense}</Descriptions.Item>
                    <Descriptions.Item label="คำอธิบาย" span={3}>
                        <span
                            style={{
                                fontFamily: 'inherit'
                            }}
                        >
                            <ReactMarkdown
                                remarkPlugins={[remarkGfm]}
                            >
                                {course.description}
                            </ReactMarkdown>
                        </span>
                    </Descriptions.Item>
                    <Descriptions.Item label="ทักษะที่จะได้รับ" span={3}>
                        { course.skills.map((skill) => {
                            return <Tag color={'green'}>{skill.name}</Tag>
                        }) }
                    </Descriptions.Item>
                    <Descriptions.Item label="เว็บไซต์" span={3}>
                        { course.url ? <a href={course.url} target={'_blank'}><LinkOutlined /> {course.url}</a> : 'ไม่มี' }
                    </Descriptions.Item>
                    <Descriptions.Item label="รูปภาพ">
                        <Image
                            src={`${process.env.REACT_APP_API_BASE}/course/${course.id}/image` || ''}
                            alt="course image"
                            fallback={'/images/fallback.jpg'}
                            height={272}
                        />
                    </Descriptions.Item>
                </Descriptions>
            </div>
        </>
    });

    return <>
        <Drawer
            height="calc(100% - 64px)"
            placement={'bottom'}
            title={'รายละเอียด'}
            visible={visible}
            onClose={onClose}
        >
            <Body/>
        </Drawer>
    </>
})

export default CourseDrawer;
